import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, BookOpen } from "lucide-react";

export default function BlogSection() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/posts`)
      .then((r) => r.json())
      .then((d) => setPosts((Array.isArray(d) ? d : []).slice(0, 3)))
      .catch(() => {});
  }, []);
  if (!posts.length) return null;
  return (
    <section className="py-20" data-testid="blog-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.5 }}>
          <p className="flex items-center gap-2 font-mono text-[10px] font-bold uppercase tracking-[0.22em] text-amber-400">
            <BookOpen size={13} /> Exam Tips Blog
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-white sm:text-4xl">Padhai ke smart tips</h2>
          <p className="mt-2 text-sm text-slate-400">Revision plans, MCQ strategy, exam-day tips — Hinglish me seedhi baat.</p>
        </motion.div>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-testid="blog-preview-grid">
          {posts.map((p, i) => (
            <motion.div key={p.id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.5, delay: i * 0.1 }}>
              <Link to={`/blog/${p.slug}`} data-testid={`blog-preview-${i}`}
                className="group flex h-full gap-4 rounded-3xl border border-white/10 bg-ink2 p-4 transition-all hover:border-amber-500/50">
                {p.image_url ? (
                  <img src={p.image_url} alt={p.title} loading="lazy" className="h-20 w-28 shrink-0 rounded-2xl object-cover" data-testid={`blog-preview-img-${i}`} />
                ) : (
                  <div className="flex h-20 w-28 shrink-0 items-center justify-center rounded-2xl bg-amber-500/10 text-amber-400"><BookOpen size={22} /></div>
                )}
                <div className="min-w-0">
                  <h3 className="line-clamp-2 font-display text-sm font-extrabold leading-snug text-white group-hover:text-amber-400">{p.title}</h3>
                  <p className="mt-1.5 font-mono text-[10px] uppercase tracking-wider text-slate-500">
                    {new Date(p.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short" })} — padhein →
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
        <div className="mt-8 text-center">
          <Link to="/blog" data-testid="blog-all-link" className="inline-flex items-center gap-2 rounded-full border border-white/15 px-7 py-3 text-sm font-bold text-slate-200 hover:border-amber-500 hover:text-amber-400">
            Saare exam tips padhein <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </section>
  );
}
